// fr strings for messages/checkout.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const checkout: Dict = {
  "checkout.declined":
    "Ta carte a été refusée. Contacte ta banque ou essaie un autre moyen de paiement.",
  "checkout.trialStarted": "Ton essai gratuit a commencé !",
  "checkout.thanks": "Merci pour ton achat !",
  "checkout.startTrial": "Commencer l'essai gratuit",
  "checkout.pay": "Payer",
};

export default checkout;
